module.exports = __webpack_public_path__ + "static/Gza-Seminegra-d4d7bdf1a6a72d8a25229ebd1b344386.woff2";